import React from 'react';
import { Link } from 'react-router-dom';
import SubscriptionStatus from "./SubscriptionStatus";


const TeamsTable = ({ teams }) => {
  
  if (teams.length === 0) {
    return <p>No teams found</p>;
  }

  return (
    <table>
      <thead>
        <tr>
          <th>Status</th>
          <th>Team Name</th>
          <th>Plan</th>
        </tr>
      </thead>
      <tbody>
        {teams.map(team => (
          <tr key={team.id}>
            <td>
              <SubscriptionStatus
                plan={team.plan}
                renewalDate={team.period_end_time}
                price={team.amount_in_cents}
              />
            </td>
            <td><Link to={`/team/${team.id}`}>{team.name}</Link></td>
            <td>{team.plan}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TeamsTable;
